import { render, staticRenderFns } from "./HelpCenterButton.vue?vue&type=template&id=65df515c&scoped=true&"
import script from "./HelpCenterButton.vue?vue&type=script&lang=js&"
export * from "./HelpCenterButton.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterButton.vue?vue&type=style&index=0&id=65df515c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df515c",
  null
  
)

export default component.exports